import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Wrapper = styled.section`
  position: relative;
  min-height: calc(100svh - 63px);
  display: flex;
  align-items: center;
  padding: clamp(56px, 6vw, 96px) clamp(20px, 5vw, 96px);
  background: radial-gradient(
    120% 90% at 12% -10%,
    rgba(255, 140, 85, 0.12) 0%,
    ${colors.background} 58%
  );
`;

export const Grid = styled.div`
  width: 100%;
  max-width: 1720px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 380px), 1fr));
  gap: clamp(40px, 5vw, 88px);
  align-items: center;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid ${colors.borderAccent};
  background: ${colors.surface};

  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.primary};
`;

export const BadgeDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: ${colors.primary};
  display: block;
`;

export const Heading = styled.h1`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: clamp(40px, 5.4vw, 68px);
  line-height: 1.03;
  letter-spacing: -0.02em;
  margin: 26px 0 0;
  text-wrap: pretty;

  span {
    color: ${colors.primary};
  }
`;

export const Lead = styled.p`
  font-size: 19px;
  line-height: 1.6;
  color: ${colors.textSecondary};
  max-width: 560px;
  margin: 22px 0 0;
  text-wrap: pretty;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 34px;
`;

export const TrialNote = styled.p`
  margin: 20px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.textFaintest};
  letter-spacing: 0.02em;
`;

export const MockupCard = styled.div`
  position: relative;
  border-radius: 40px;
  border: 1px solid ${colors.border};
  background: ${colors.surface};
  padding: 18px;
  box-shadow: 0 40px 90px rgba(0, 0, 0, 0.5);
`;

export const MockupScreenshot = styled.div`
  position: relative;
  width: 100%;
  border-radius: 30px;
  background-color: ${colors.surfaceSunken};
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
`;

export const StatCard = styled.div`
  border-radius: 20px;
  background: ${colors.surfaceAccent};
  padding: 16px;
`;

export const StatValue = styled.div`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: 22px;
  color: ${colors.textPrimary};
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: ${colors.textFaint};
  font-weight: 600;
`;
